module.exports = __webpack_public_path__ + "img/topic-wheel.4d67707c.png";